<template>
  <div class='calculator' onselectstart='return false'>
    <div class='display'>{{ formatCurrency(display, 2) }}</div>
    <div @click='clear' class='button darker'>CA</div>
    <div @click='sign' class='button darker'>+/-</div>
    <div @click='percent' class='button darker'>%</div>
    <div @click='divide' class='button operator'>÷</div>
    <div @click='append(7)' id="b7" class='button'>7</div>
    <div @click='append(8)' id="b8" class='button'>8</div>
    <div @click='append(9)' id="b9" class='button'>9</div>
    <div @click='multiply' class='button operator'>x</div>
    <div @click='append(4)' id="b4" class='button'>4</div>
    <div @click='append(5)' id="b5" class='button'>5</div>
    <div @click='append(6)' id="b6" class='button'>6</div>
    <div @click='subtract' class='button operator'>-</div>
    <div @click='append(1)' id="b1" class='button'>1</div>
    <div @click='append(2)' id="b2" class='button'>2</div>
    <div @click='append(3)' id="b3" class='button'>3</div>
    <div @click='add' class='button operator'>+</div>
    <div @click='append(0)' id="b0" class='button zero button-bottom double-width'>0</div>
    <div @click='decimal' class='button darker button-bottom'>.</div>
    <div @click='equal' class='button operator button-bottom'>=</div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  data() {
    return {
      previous: null,
      display: 0,
      operator: () => {
        return this.display;
      },
      operatorClicked: false
    };
  },
  methods: {
    pressKey (keyCode) {
      console.log('pressing key', keyCode)

      if (keyCode == 48) {
        this.append(0)
        $('#b0').addClass('flash-me')
        setTimeout(()=>{ $('#b0').removeClass('flash-me')}, 100)
      } else if (keyCode == 49) {
        this.append(1)
        $('#b1').addClass('flash-me')
        setTimeout(()=>{ $('#b1').removeClass('flash-me')}, 100)
      } else if (keyCode == 50) {
        this.append(2)
        $('#b2').addClass('flash-me')
        setTimeout(()=>{ $('#b2').removeClass('flash-me')}, 100)
      } else if (keyCode == 51) {
        console.log('3...')
        this.append(3)
        $('#b3').addClass('flash-me')
        setTimeout(()=>{ $('#b3').removeClass('flash-me')}, 100)
      } else if (keyCode == 52) {
        this.append(4)
        $('#b4').addClass('flash-me')
        setTimeout(()=>{ $('#b4').removeClass('flash-me')}, 100)
      } else if (keyCode == 53) {
        this.append(5)
        $('#b5').addClass('flash-me')
        setTimeout(()=>{ $('#b5').removeClass('flash-me')}, 100)
      } else if (keyCode == 54) {
        this.append(6)
        $('#b6').addClass('flash-me')
        setTimeout(()=>{ $('#b6').removeClass('flash-me')}, 100)
      } else if (keyCode == 55) {
        this.append(7)
        $('#b7').addClass('flash-me')
        setTimeout(()=>{ $('#b7').removeClass('flash-me')}, 100)
      } else if (keyCode == 56) {
        this.append(8)
        $('#b8').addClass('flash-me')
        setTimeout(()=>{ $('#b8').removeClass('flash-me')}, 100)
      } else if (keyCode == 57) {
        this.append(9)
        $('#b9').addClass('flash-me')
        setTimeout(()=>{ $('#b9').removeClass('flash-me')}, 100)
      } else if (keyCode == 106) {
        this.multiply()
      } else if (keyCode == 107) {
        this.add()
      } else if (keyCode == 109) {
        this.subtract()
      } else if (keyCode == 110) {
        this.decimal()
      }  else if (keyCode == 111) {
        this.divide()
      } else if (keyCode == 13) {
        this.equal()
      } else if (keyCode == 8) {
        this.clear()
      } else if (keyCode == 46) {
        this.clear()
      }


       /*else if (keyCode == 57) {
        this.append(9)
      } else if (keyCode == 57) {
        this.append(9)
      } else if (keyCode == 57) {
        this.append(9)
      } else if (keyCode == 57) {
        this.append(9)
      } */
    },
    formatCurrency: function (amount, digits) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: digits || 0
      });

      return formatter.format(amount);
    },
    clear() {
      this.display = 0;
    },
    sign() {
      this.display =
        this.display < 0
          ? (this.display = this.display - this.display * 2)
          : (this.display = this.display - this.display * 2);
    },
    percent() {
      this.display = this.display / 100;
    },
    append(number) {
      if (this.operatorClicked === true) {
        this.display = "";
        this.operatorClicked = false;
      }
      this.display =
        this.display === 0
          ? (this.display = number)
          : "" + this.display + number;
    },
    decimal() {
      if (this.display.indexOf(".") === -1) {
        this.append(".");
      }
    },
    divide() {
      this.operator = (a, b) => a / b;
      this.previous = this.display;
      this.operatorClicked = true;
    },
    multiply() {
      this.operator = (a, b) => a * b;
      this.previous = this.display;
      this.operatorClicked = true;
    },
    subtract() {
      this.operator = (a, b) => a - b;
      this.previous = this.display;
      this.operatorClicked = true;
    },
    add() {
      this.operator = (a, b) => a + b;
      this.previous = this.display;
      this.operatorClicked = true;
    },
    equal() {
      this.display = this.operator(Number(this.previous), Number(this.display));
      this.previous = null;
      this.operatorClicked = true;
    }
  }
};
</script>

<style scoped>
/*@import "../../styles/settings.scss";*/

.calculator {
  margin: 0 auto;
  width: 100%;
  font-size: 2rem;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  -o-flex-wrap: wrap;
  flex-wrap: wrap;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: minmax(10vh, auto);
  justify-content: space-between;
  /*border: 5px solid #111;*/
  /*box-shadow: -3px 3px 15px rgba(17,17,17,0.4);*/
  line-height: 64px;
}

.calculator > div {
  max-height: 74px;
}

.display {
  width: 100%;
  margin-bottom: 20px;
  height: 64px;
  /*width: 270px;*/
  border-radius: 5px;
  background-color: #ffffff;
  box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  grid-column: 1 / 5;
  /*border: 1px solid #111;*/
  border-top: 0;
  white-space: nowrap;
  font-size: 2.5rem;
  cursor: default;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: "Nexa";
  font-weight: 600;
  padding: 8px 12px;
  text-align: right;
  line-height: 1.3em;
}

.zero {
  grid-column: 1 / 3;
}

.button {
  /*margin-right: 12px;*/
  margin-bottom: 16px;
  font-family: "Nexa";
  font-weight: 600;
  height: 56px;
  width: 56px;
  background-color: #313131;
  font-size: 24px;
  color: white;
  border-radius: 50%;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: center;
  align-items: center;
  justify-content: center;

  /*background: hsl(0, 0%, 80%);*/
  /*background: linear-gradient(15deg,hsl(0, 0%, 70%) 0%, hsl(0, 0%, 80%) 100%);*/
  /*border: 1px solid #111;*/
  cursor: pointer;
}

.button:hover {
  opacity: 0.8;
}

.button:active {
  outline: none;
  /*border: 1px solid #000000BF; */
  /*box-shadow: inset 0px 0px 5px #00000080; */
  /*-moz-box-shadow: inset 0px 0px 5px #00000080;*/
  /*-webkit-box-shadow: inset 0px 0px 5px #00000080;*/
}

.button-bottom {
  border-bottom: 0;
}

.operator {
  background-color: #f2397d;
  color: white;
  /*background: hsl(153, 48%, 49%);*/
  /*background: linear-gradient(15deg,hsl(153, 48%, 39%) 0%, hsl(153, 48%, 49%) 100%);*/
}

.darker {
  background-color: #d8d8d8;
  color: #313131;
  /*background: hsl(0, 0%, 70%);*/
  /*background: linear-gradient(15deg, hsl(0, 0%, 60%) 0%, hsl(0, 0%, 70%) 100%);*/
}

.double-width {
  width: 127px;
  border-radius: 28px;
}

.flash-me {
  border: 8px solid white;
}

</style>
